// extracted by mini-css-extract-plugin
module.exports = {"container":"CardPanel_container__xP8qy"};